import { Typography } from '@design-system/components/typography/typography';

export const StepCount = ({ step, max }: { step: number; max?: number }) => (
  <Typography variant="body" size="large" className="absolute t-0 l-0">
    {step}/{max || 5}
  </Typography>
);
